import { Breadcrumb, Col, Input, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as ArchiveRestore } from "../../../image/ArchiveRestore.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
const { Search } = Input;

const ArchivedCategoryList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [archivedCategoryList, setArchivedCategoryList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [searchText, setSearchText] = useState("");
  // State initialisation
  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // Fetch Archive Category List
  useEffect(() => {
    const getCategoryArchiveList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("category-tree-archive/", state);

        if (apiResponse.data.results.success) {
          setArchivedCategoryList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getCategoryArchiveList();
  }, [state, reload, t]);

  // function to Handle The Change in Table
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };
  //   // Function of Shorting enum Value
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }

    if (sortField === "description" && sortOrder === "ascend") {
      sortingEnumKey = "description";
    }
    if (sortField === "description" && sortOrder === "descend") {
      sortingEnumKey = "-description";
    }
    if (sortField === "gst_rate" && sortOrder === "ascend") {
      sortingEnumKey = "gst_rate";
    }
    if (sortField === "gst_rate" && sortOrder === "descend") {
      sortingEnumKey = "-gst_rate";
    }

    return sortingEnumKey;
  };

 // Handle search input change with debounce to delay search execution
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  // Debounce function to delay the execution of the search operation
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  // Configuration for row selection in the table
  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };
// Function to restore the selected categories or a single category
  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("category-tree-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("category_restore_successfully4"));
        setReload(!reload);
        setSelectedRow([]);
        navigate("/category");
      } else {
        ErrorNotificationMsg(t(" error_in_restore_category"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  
  // Function to open an image in a new browser tab
  const openImageInNewTab = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  const columns = [
    {
      title: "Category Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: true,
    },
    {
      title: "GST (%)",
      render: (gst_rate) => <>{gst_rate} %</>,
      dataIndex: "gst_rate",
      key: "gst_rate",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Restore
              </span>
            }
          >
            <Popconfirm
              className="action"
              title={t("pop_restore_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleRestore(record.id)}
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">

            <h3>{t("archived_category6")}</h3>


            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/category">{t("pl_category")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archiveList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

     <div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body" style={{padding:'0'}}>
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
          </Row>
<div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={archivedCategoryList}
            scroll={{ x: 800 }}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (totalCount) => `Total ${totalCount} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("pl_back_to_list")}
              onClick={() =>
                navigate(
                  `/category`
                )
              }
            />
          </div>
        </div>
      </section>
      </div>
      </div>
    </>
  );
};

export default ArchivedCategoryList;
